const activitiesSlider = document.querySelectorAll('[data-slider="activities-slider"]');

if (activitiesSlider.length > 0) {
  const activitiesSliderOptions = {
    slidesPerView: 1,
    speed: 200,
    spaceBetween: 0,
    direction: 'vertical',
    effect: 'creative',
    allowTouchMove: false,
    simulateTouch: false,
    creativeEffect: {
      prev: { shadow: false, translate: [0, 0, -1] },
      next: { translate: [0, 0, 0], opacity: 0 },
    },
  };

  const initActivitiesSlider = () => {
    const controller = new ScrollMagic.Controller();

    activitiesSlider.forEach((el) => {
      const module = el.closest('.activities-module');
      const images = module.querySelectorAll('.activities-module__image');
      const links = module.querySelectorAll('.activities-module__title');
      const slider = new Swiper(el, activitiesSliderOptions);

      const setDirections = () =>
        slider.slides.forEach((slide, i) => slide.style.setProperty('--dir', Math.sign(i - slider.activeIndex)));

      setDirections();
      slider.on('slideChange', setDirections);

      links.forEach((link) => {
        link.addEventListener('mouseenter', () => {
          const index = link.dataset.item;

          removeActiveClass([...links, ...images]);
          link.classList.add('is-active');
          el.querySelector(`[data-image="${index}"]`).classList.add('is-active');

          slider.slideTo(index);
        });
      });

      new ScrollMagic.Scene({ triggerElement: el, triggerHook: 0, duration: '200%' })
        .setClassToggle(el, 'is-active')
        .addTo(controller);
    });
  };

  setupResponsiveSliders({
    sliderElements: activitiesSlider,
    breakpoint: breakpointMd,
    initSlider: initActivitiesSlider,
    mobileFallback: () => {},
    parentSelector: '[data-slider-parent]',
  });
}
